// Calendar dates are local calendar values, not UTC instants. Timestamp APIs
// provide an explicit offset, which Date converts to the browser timezone.
export const parseDateValue = value => {
  if (value instanceof Date) return value;
  if (value === null || value === undefined || value === '') return new Date(NaN);
  const raw = typeof value === 'string' ? value.trim() : value;
  const calendar = typeof raw === 'string' && raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (calendar) return new Date(+calendar[1], +calendar[2] - 1, +calendar[3]);
  // Keep legacy timezone-less values local: guessing UTC here would break
  // installations that historically stored local time. New APIs include offsets.
  return new Date(typeof raw === 'string' ? raw.replace(/^(\d{4}-\d{2}-\d{2}) /, '$1T') : raw);
};
